'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _AppConstants = require('../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _PayoffModal = require('./PayoffModal');

var _PayoffModal2 = _interopRequireDefault(_PayoffModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PAYOFF_ACTIONS = _AppConstants2.default.PAYOFF_ACTIONS;
var PayoffMenuItems = (_dec = (0, _mobxReact.inject)('UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(PayoffMenuItems, _Component);

  function PayoffMenuItems() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PayoffMenuItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PayoffMenuItems.__proto__ || Object.getPrototypeOf(PayoffMenuItems)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'payoffAction', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PayoffMenuItems, [{
    key: 'onOptionClick',
    value: function onOptionClick(action) {
      this.payoffAction = action;
      this.props.UiStore.modals.Payoff.open();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _case = _props._case,
          isDisabled = _props.isDisabled,
          UiStore = _props.UiStore;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _MenuItem2.default,
          { header: true },
          'Generate Payoff'
        ),
        _react2.default.createElement(
          _MenuItem2.default,
          { disabled: isDisabled, eventKey: PAYOFF_ACTIONS.email, onSelect: this.onOptionClick },
          'Email'
        ),
        _react2.default.createElement(
          _MenuItem2.default,
          { disabled: isDisabled, eventKey: PAYOFF_ACTIONS.download, onSelect: this.onOptionClick },
          'Download'
        ),
        _react2.default.createElement(_MenuItem2.default, { divider: true }),
        UiStore.modals.Payoff.showing() && _react2.default.createElement(_PayoffModal2.default, {
          _case: _case,
          action: this.payoffAction || 'download'
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PayoffMenuItems;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  isDisabled: _propTypes2.default.bool,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'payoffAction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class) || _class) || _class);
var _default = PayoffMenuItems;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PAYOFF_ACTIONS, 'PAYOFF_ACTIONS', '/app/src/components/page-case/PayoffMenuItems.js');
  reactHotLoader.register(PayoffMenuItems, 'PayoffMenuItems', '/app/src/components/page-case/PayoffMenuItems.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/PayoffMenuItems.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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